<modal
  [condition]="showErrorModal"
  [config]="{ header: { title: 'File Failure', icon: 'warning' } }"
  (cancel)="modalClosed.emit()"
>
  <div
    body
    class="t-html"
    [innerHTML]="
      exportError ||
      'There was an error downloading the document. Please try again later.'
    "
  ></div>
  <div footer class="ListView__export-modal__footer">
    <zip-button
      (zipButtonClicked)="modalClosed.emit()"
      [config]="{ content: 'Close', level: 'high' }"
    >
    </zip-button>
  </div>
</modal>
